import { billingActions, commonActions } from '@/redux/modules';
import { SubscriptionsQuestionTypes } from '@/redux/modules/billing/billing.types';
import { locale } from '@/utils/locale';
import { debounce } from '@/utils/debounce';

const createSubscriptionCancelRenewalHandler = ({
  history,
  questions,
  step,
  setStep,
  subscriptionAnalytics,
  subscriptions,
  subscriptionId,
  subscriptionType,
  stepsStatus,
  questionId,
  optionId,
  setSubscription,
  dispatch,
  openPreChatCancelFlow,
}) => {
  const resetCancelRenewalSurvey = () => {
    dispatch(billingActions.subscriptions.cancel.set({
      questionId: null,
      optionId: null,
      questionValue: '',
      reason: '',
    }));
  };

  const handleOnCategorySelect = (categoryId) => {
    const question = questions[SubscriptionsQuestionTypes.CANCEL_RENEWAL]
      && questions[SubscriptionsQuestionTypes.CANCEL_RENEWAL][0];
    const found = question && question.reasons.find(r => r.id === categoryId);
    dispatch(billingActions.subscriptions.cancel.set({
      questionId: categoryId,
      questionValue: found ? found.label : '',
      optionId: null,
    }));
  };

  const handleOnSubOptionSelect = (optionId) => {
    dispatch(billingActions.subscriptions.cancel.set({ optionId }));
  };

  const handleOnCommentChange = debounce((commentValue) => {
    dispatch(billingActions.subscriptions.cancel.set({ reason: commentValue }));
  });

  const onFowardStepClick = () => {
    const redirect = () => {
      history.push(`${locale('routes.subscriptions')}${locale('routes.manageSubscription')}/${subscriptionId}/${subscriptionType}`);
    };

    const steps = {
      [stepsStatus.SURVEY]: () => {
        subscriptionAnalytics.cancelSubscriptionClick('3_continuar_pesquisa_respondida_cancelar_renovacao');
        setStep(stepsStatus.CONFIRMATION);
      },
      [stepsStatus.CONFIRMATION]: () => {
        subscriptionAnalytics.cancelSubscriptionClick('4_cta_cancelar_renovacao');

        subscriptionAnalytics.cancelRenewalConfirmationClick();
        setStep(stepsStatus.DONE);
        const subscription = subscriptions.find(item => item.id === Number(subscriptionId));
        dispatch(billingActions.subscriptions.cancelRenewal.request(
          subscription,
          subscriptionId,
          subscriptionType,
          redirect,
        ));
      },
    };

    steps[step]();
  };

  const onPreviousStepClick = () => {
    const steps = {
      [stepsStatus.CONFIRMATION]: () => {
        subscriptionAnalytics.cancelSubscriptionClick('4_voltar_para_pesquisa_cancelar_renovacao');
        setStep(stepsStatus.SURVEY);
      },
      [stepsStatus.SURVEY]: () => {
        subscriptionAnalytics.cancelSubscriptionClick('3_voltar_pesquisa_respondida_cancelar_renovacao');
        resetCancelRenewalSurvey();
        openPreChatCancelFlow();
        history.push(locale('routes.subscriptions'));
      },
    };

    steps[step]();
  };

  const handleOnStopCancel = () => {
    subscriptionAnalytics.cancelSubscriptionClick('4_desisir_cancelar_renovacao');
    resetCancelRenewalSurvey();
    openPreChatCancelFlow();
    history.push(locale('routes.subscriptions'));
  };

  const isSurveyStepComplete = () => !questionId || optionId === null;

  const settingSubscriptions = () => {
    setSubscription(subscriptions.find(subscription => subscription.id === Number(subscriptionId)
        && subscription.type === subscriptionType));
  };

  const requestQuestions = () => {
    dispatch(billingActions.subscriptions.questions.request(
      SubscriptionsQuestionTypes.CANCEL_RENEWAL,
    ));
  };

  const findSubscription = () => {
    const subItem = subscriptions.find(({ id }) => id === subscriptionId);
    subItem && setSubscription(subItem);
  };

  const requestSubscription = () => {
    dispatch(billingActions.subscription.request({ subscriptionId, subscriptionType }));
  };

  const reset = () => {
    resetCancelRenewalSurvey();
  };

  const redirect = () => {
    setTimeout(() => {
      history.push(redirect.url);
      dispatch(commonActions.redirect.clear());
    }, 3000);
  };

  return {
    onPreviousStepClick,
    onFowardStepClick,
    handleOnStopCancel,
    handleOnCategorySelect,
    handleOnSubOptionSelect,
    handleOnCommentChange,
    resetCancelRenewalSurvey,
    isSurveyStepComplete,
    settingSubscriptions,
    requestQuestions,
    findSubscription,
    requestSubscription,
    reset,
    redirect,
  };
};

export default createSubscriptionCancelRenewalHandler;
